
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/video-translator/[slug]",
      function () {
        return require("private-next-pages/tools/video-translator/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/video-translator/[slug]"])
      });
    }
  